import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

const BASE_URL = '/contact'

export default {
  retrieve: (pk, errorHandling = true) => axios.get(`${BASE_URL}/${pk}`)
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling)),

  sendMail: (params) => axios.get(`${BASE_URL}/send_mail`, { params: params })
    .then(response => response.data)
    .catch(error => errorHandler(error))
}
